module.exports = __webpack_public_path__ + "img/symphony_540_caramel.65ea4665.jpg";